import { FC } from 'react';
import { useTranslation } from 'next-i18next';
import styled from 'styled-components';

import { ButtonIw } from '@/_pages/interwill/components/ButtonIw';
import { media } from '@/shared/components';
import { COLORS } from '@/shared/constants/colors';
import { Icon } from '@/shared/uikit/Icon';
import { Title } from '@/shared/uikit/Title';
import { useModalsStore } from '@/widgets/modals/modals.store';
import { RecordingUnavailableModalProps } from '@/widgets/modals/types';

import { ModalContainerV4 } from '../containers/ModalContainerV4';

export const RecordingUnavailableModal: FC<RecordingUnavailableModalProps> = () => {
  const { t } = useTranslation('widgets/modals', { keyPrefix: 'recordingUnavailable' });
  const modals = useModalsStore();

  return (
    <ModalContainerV4>
      <Container>
        <Cross>
          <Icon name="x" size="s24" />
        </Cross>
        <Title bold size={22}>
          {t('title')}
        </Title>
        <Content>
          <b>{t('text')}</b>
        </Content>
        <Buttons>
          <ButtonIw onClick={modals.closeModal}>{t('btn')}</ButtonIw>
        </Buttons>
      </Container>
    </ModalContainerV4>
  );
};

const Cross = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${COLORS.systemFlame200};
  background: ${COLORS.systemFlame100};
`;

const Content = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  font-size: 14px;
  padding-bottom: 32px;
  gap: 12px;
`;

const Buttons = styled.div`
  display: flex;
  gap: 16px;
  justify-content: flex-end;
  width: 100%;

  ${media.iwMobile} {
    flex-direction: column-reverse;
    margin-top: 16px;
  }
`;

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 12px;
`;
